"use client";
import * as React from "react";
const SvgStarRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "m8 13.062 3.88 2.302c.71.422 1.58-.202 1.393-.99l-1.028-4.33 3.43-2.916c.627-.532.29-1.54-.532-1.605l-4.516-.376-1.767-4.09c-.318-.743-1.402-.743-1.72 0L5.373 5.138l-4.516.376C.035 5.578-.302 6.587.324 7.12l3.431 2.917-1.028 4.328c-.187.789.683 1.413 1.393.99L8 13.063Z" }));
export {
  SvgStarRound as default
};
